import { NavLink } from 'react-router';
import React from 'react';
import {
  dateFormatter, dateTimeFormatter, infoLabelWithStatus, locationFormatter,
} from '../../../utils/formatters';

export const visitColumns = [
  {
    dataField: 'trip_started_at',
    text: 'Дата и время начала поездки',
    headerClassName: 'start-date-column',
    formatter: dateTimeFormatter,
  },
  {
    dataField: 'trip_ended_at',
    headerClassName: 'end-date-column',
    text: 'Дата и время окончания поездки',
    formatter: dateTimeFormatter,
  },
  {
    dataField: 'trip_start_point',
    disableSort: true,
    headerClassName: 'start-point-column',
    text: 'Начальная точка маршрута',
    formatter: (_, item) => locationFormatter({ latitude: item.trip_start_point?.[0], longitude: item.trip_start_point?.[1] }),
  },
  {
    dataField: 'trip_end_point',
    disableSort: true,
    headerClassName: 'end-point-column',
    text: 'Конечная точка маршрута',
    formatter: (_, item) => locationFormatter({ latitude: item.trip_end_point?.[0], longitude: item.trip_end_point?.[1] }),
  },
  {
    dataField: 'vehicle',
    headerClassName: 'record-number-lt-column',
    text: 'Номер записи ЛТ',
    formatter: item => <NavLink target="_blank" to={`/region-registry/passenger-taxi?registry_id=${item?.registry_vehicle?.id}`}>{item?.registry_vehicle?.number}</NavLink>,
    disableSort: true,
    sortField: 'vehicle.registry_vehicle.number',
  },
  {
    dataField: 'carrier_registry_number',
    headerClassName: 'record-number-rp-column',
    text: 'Номер записи РП',
    formatter: (_, item) => <NavLink target="_blank" to={`/region-registry-carrier?registry_id=${item?.carrier_id}`}>{item?.carrier_registry_number}</NavLink>,
  },
  {
    dataField: 'vehicle',
    headerClassName: 'vehicle-reg-number-column',
    disableSort: true,
    text: 'ГРН ТС',
    formatter: item => item?.vehicle_lpn,
    sortField: 'vehicle.vehicle_lpn',
  },
];

export const visitDetailsColumns = [
  {
    dataField: 'driver_cost',
    headerClassName: 'driver-cost-column',
    text: 'Стоимость поездки',
    formatter: item => (item ? `${item} Р` : ''),
  },
];

export const visitAdditionalColumns = [
  {
    dataField: 'driver_id',
    headerClassName: 'driver-id-column',
    text: 'ID водителя',
  },
  {
    dataField: 'carrier',
    headerClassName: 'carrier-column',
    text: 'Перевозчик',
  },
];
